import { createContext } from 'react'

export interface ChooseOrgAndAppContextType {
  customerId: string
  orgId: string
  appId: string
  orgName: string
  setOrgName: (id: string) => void
  appName: string
  setAppName: (id: string) => void
  setCustomerId: (id: string) => void
  setOrgId: (id: string) => void
  setAppId: (id: string) => void
}

export const OrgAppContext = createContext<ChooseOrgAndAppContextType>({
  customerId: '',
  orgId: '',
  appId: '',
  orgName: '',
  setOrgName: () => {},
  appName: '',
  setAppName: () => {},
  setCustomerId: () => {},
  setOrgId: () => {},
  setAppId: () => {},
})
